<template>
    <div style="margin-top: 63px">
        <div class="hero">
            <div class="hero-ctn">
                <h1>
                    {{ $t('testimonyTitle') }}
                </h1>
                <p>
                    {{ $t('testimonyDescription') }}
                </p>
            </div>
        </div>
        <div style="background-color: #f5f6fa;" class="pb-10">
            <div class="container">
                <div class="masonry">
                    <div class="card-2" v-for="(item, idx) in testimonies" :key="idx">
                        <p class="text-center">{{ item.feedback }}</p>
                        <div class="profile mt-5 d-flex" style="align-items: center">
                            <div class="avatar">
                                <img :src="$utils.loadImage(item.image_url)" alt="" width="60" height="60"
                                    class="avatar-image" />
                            </div>
                            <div class="testi-profile ml-5">
                                <div class="name">{{ item.name }}</div>
                                <div class="description">
                                    {{ item.job }} {{ item.place }}
                                </div>
                                <v-img v-if="item.linkedin" src="/img/home/linkedin.png" alt="" width="23" height="23"
                                    @click="redirectToLinkedIn(item.linkedin, item.name)" class="linkedin-image cursor-pointer" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-10">
                    <Pagination @pageChanged="onPageChanged" :currentPage="currentPage" :totalPages="total" />
                </div>
            </div>
        </div>
        <v-card elevation="0" class="call-center-container">
            <v-row style="padding: 40px">
                <v-col cols="7">
                    <div class="call-center-title">
                        {{ $t('testimony1') }}
                    </div>
                    <div class="call-center-desc">
                        {{ $t('testimony2') }}
                    </div>
                </v-col>
                <v-col cols="1" />
                <v-col cols="4" class="call-center-button" @click="goToHome">
                    <v-btn class="btn" elevation="0"> {{ $t('testimony3') }} </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import Pagination from '@/components/others/Pagination.vue'

export default {
    name: "DekstopTestimony",
    components: {
        Pagination
    },
    data() {
        return {
            testimonies: [],
            currentPage: 1,
            total: 1,
        }
    },
    watch: {
        "$i18n.locale"() {
            this.getTestimoni();
        },
    },
    methods: {
        async getTestimoni() {
            try {
                const resp = await this.$http.get(`/v1/testimony?page=${this.currentPage}&per_page=20`);
                this.testimonies = resp.data.data.testimonies;
                if (resp.data.data.total) {
                    this.total = parseInt(resp.data.data.total / 20) + 1;
                }
            } catch (err) {
                console.error(err);
            }
        },
        onPageChanged(page) {
            this.currentPage = page;
            this.$gtag.event('click', {
                event_category: 'Navigation',
                event_label: `Pagination Change - Page ${page} - Testimony Page`,
                value: 1,
            });
            this.getTestimoni();
        },
        page(act) {
            if (act === 'prev') {
                if (this.currentPage <= 1) return;
                this.currentPage--;
            } else {
                if (this.currentPage >= this.total) return;
                this.currentPage++;
            }
            this.$gtag.event('click', {
                event_category: 'Navigation',
                event_label: `Pagination ${act === 'prev' ? 'Previous' : 'Next'} - Page ${this.currentPage} - Testimony Page`,
                value: 1,
            });
            this.getTestimoni();
        },
        redirectToLinkedIn(url, name) {
            this.$gtag.event('click', {
                event_category: 'Navigation',
                event_label: `Visit LinkedIn - ${name} - Testimony Page`,
                value: 1,
            });
            window.open(url, '_blank');
        },
        goToHome() {
            this.$gtag.event('click', {
                event_category: 'Navigation',
                event_label: 'Go to Home - Testimony Page',
                value: 1,
            });
            this.$router.push('/');
        },
    },
    mounted() {
        this.getTestimoni();
        this.$gtag.pageview(this.$route);
    }
}
</script>

<style scoped src="./testimony.css"></style>